import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon from "@insite/mobius/Icon";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SpecialMessageIcon from "@tCentro/Icons/SpecialMessageIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: ProductSpecialMessageStyles;
    specialMessage?: string;
}

type Props = OwnProps;

export interface ProductSpecialMessageStyles {
    specialMessage?: TypographyProps;
    specialMessageIcon?: InjectableCss;
}

export const productSpecialMessageStyles: ProductSpecialMessageStyles = {
    specialMessage: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
            text-transform: capitalize;
            color: ${COLORS.lightGreen};
        `,
    },
    specialMessageIcon: {
        css: css`
            vertical-align: middle;
        `,
    },
};

const ProductSpecialMessage: FC<Props> = ({ specialMessage }) => {
    return (
        <StyledWrapper>
            <StyledWrapper {...productSpecialMessageStyles.specialMessage}><Icon src={SpecialMessageIcon} {...productSpecialMessageStyles.specialMessageIcon} />{specialMessage}</StyledWrapper>
        </StyledWrapper>
    );
};

export default ProductSpecialMessage;
